import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';

@Injectable({ providedIn: 'root' })
export class ComponentDefaultsEditService {

  constructor(
    private http: HttpClient,
    private jsonObjectFactory: JsonObjectFactoryService,
  ) {}

  /**
   * Check lock status for tax return.
   * AngularJS: action_code 'n10cpv'
   */
  getLockStatus(baseUrl: string, scenario: string, jcdKey: any, globalService: any): Observable<any> {
    const url = baseUrl + '/loadJsonObject';
    const params: any = {
      action_code: 'n10cpv',
      p_scenario: scenario,
      p_jcd_key: jcdKey,
    };
    return this.jsonObjectFactory.getJSONObj(url, params, globalService);
  }

  /**
   * Get code master data for all dropdowns.
   * AngularJS: action_code 'dbty56'
   */
  getCodeMastData(baseUrl: string, scenario: string, jcdKey: any, ccKey: any, globalService: any): Observable<any> {
    const url = baseUrl + '/loadJsonObject';
    const params: any = {
      action_code: 'dbty56',
      p_scenario: scenario,
      p_jcd_key: jcdKey,
      cc_key: ccKey,
    };
    return this.jsonObjectFactory.getJSONObj(url, params, globalService);
  }

  /**
   * Get attribute master data (ATTRIB_KEY mapping for save payload).
   * AngularJS: action_code 'bsob9d'
   */
  getAttribMast(baseUrl: string, scenario: string, jcdKey: any, globalService: any): Observable<any> {
    const url = baseUrl + '/loadJsonObject';
    const params: any = {
      action_code: 'bsob9d',
      p_scenario: scenario,
      p_jcd_key: jcdKey,
    };
    return this.jsonObjectFactory.getJSONObj(url, params, globalService);
  }

  /**
   * Save component defaults (pivot save).
   * AngularJS: DefaultServiceFactory.saveDefaults -> POST to /saveJsonAsPivotObject?action_code=yv5r7a
   * Merges: GlobalService.globalParams + filterParams + { clob_data, clob_settings, process_name }
   */
  saveDefaults(
    baseUrl: string,
    globalParams: any,
    filterParams: any,
    settings: any,
    details: any[]
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonAsPivotObject?action_code=yv5r7a`;

    const mergedParams: any = { ...globalParams, ...filterParams };
    mergedParams.clob_data = JSON.stringify(details);
    mergedParams.clob_settings = JSON.stringify(settings);
    mergedParams.process_name = 'component-defaults-grid-save';

    const body = new URLSearchParams();
    Object.keys(mergedParams).forEach(k => {
      if (mergedParams[k] !== undefined && mergedParams[k] !== null) {
        body.set(k, String(mergedParams[k]));
      }
    });

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }
}
